import React from "react";
import { useNavigate } from "react-router";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { focusDefaultTabInAlarms } from "utils/insightsAndAlarmsUtils";
import { getAlarmsPagePath } from "utils/router.utils";
import { dateRangeFilter, formatDateLocalTZ } from "utils/utils";
import { dateComparator } from 'utils/comparatorUtils';
import { ALARMS_TABLE_STRINGS, SYSTEM_TABLE_COLUMNS } from "constants/constantStrings";

import AgTable from "components/AgTable";

const AlarmsTable = React.memo(({ activeAlarms, filterValue, setfilterAlarms, showTableFilterIcon }) => {
  const navigate = useNavigate();

  const objAppInsights = useAppInsightsHandler();

  const handleClickOnAlarmRow = event => {
    objAppInsights.trackEvent("alarmRowClick");
    focusDefaultTabInAlarms();
    const { sysId } = event.data;
    const path = getAlarmsPagePath(sysId);
    navigate(path);
  };

  const columdefs = [
    {
      field: "sysId",
      headerName: SYSTEM_TABLE_COLUMNS.sysId,
      flex: 1,
      editable: false,
      filter: showTableFilterIcon,
      newRowsAction: "keep"
    },
    {
      field: "sysName",
      headerName: SYSTEM_TABLE_COLUMNS.systemName,
      flex: 1,
      editable: false,
      filter: showTableFilterIcon,
      newRowsAction: "keep"
    },
    {
      field: "alarmId",
      headerName: ALARMS_TABLE_STRINGS.headerAlarmID,
      flex: 0.5,
      editable: false,
      filter: showTableFilterIcon,
      newRowsAction: "keep"
    },
    {
      field: "description",
      headerName: ALARMS_TABLE_STRINGS.headerAlarmDesc,
      flex: 1.5,
      editable: false,
      filter: showTableFilterIcon,
      newRowsAction: "keep"
    },
    {
      field: "timestamp",
      headerName: ALARMS_TABLE_STRINGS.headerAlarmTimestamp,
      editable: false,
      flex: 1,
      defaultSort: "desc",
      filter: "agDateColumnFilter",
      filterParams: dateRangeFilter,
      newRowsAction: "keep",
      valueFormatter: params => formatDateLocalTZ(params.data?.timestamp),
      comparator: dateComparator
    }
  ];

  return (
    <div>
      <AgTable
        rowData={activeAlarms}
        onRowClicked={handleClickOnAlarmRow}
        quickFilterText={filterValue}
        columnDefs={columdefs}
        customHeight="300px"
        setBadgeCount={setfilterAlarms}
        suppressScrollOnNewData
      />
    </div>
  );
});

export default AlarmsTable;
